import {
  MAP_CURRENT_VIEW_SET,
  MAP_PREVIOUS_VIEW_MOVE,
  MAP_NEXT_VIEW_MOVE,
} from './actions.type';

import {
    MAP_CURRENT_VIEW_INDEX_INCREMENT,
    MAP_CURRENT_VIEW_INDEX_DECREMENT,
    MAP_VIEW_ADD,
    MAP_LAST_VIEW_REMOVE,
    MAP_VIEW_RESTORING_SET,
    MAP_COORDINATE_SYSTEM_SET,
    MAP_ZOOM_SET,
    MAP_RESOLUTION_SET,
    DATA_FEED_ID_SET,
    DATA_FEED_TYPE_SET,
    DATA_FEED_NO_GEOMETRY_LAYER_ID_SET,
    MAP_SCALE_SET,
    VIEW_CENTER_SET,
    MAP_HISTORY_DATA_MODE_SET
} from './mutations.type';

const initialState = {
    views: [],
    currentViewIndex: -1,
    isViewRestoring: false,
    coordinateSystem: 'EPSG:2180',
    zoom: 3,
    resolution: undefined,
    editMode: false,
    dataFeedId: null,
    dataFeedType: null,
    dataFeedNoGeometryLayerId: null,
    scale: null,
    center: [597822.0, 514104.0],
    isHistoryDataMode: false
};

export const state = Object.assign({}, initialState);

export const actions = {
  [MAP_CURRENT_VIEW_SET](context, map) {
    let currentViewIndex = context.getters.currentViewIndex;
    let views = context.getters.views;
    let isViewRestoring = context.getters.isViewRestoring;

    if (isViewRestoring === false) {
      if (currentViewIndex < views.length - 1) {
        for (let i = views.length - 1; i > currentViewIndex; i--) {
          context.commit(MAP_LAST_VIEW_REMOVE);
        }
      }

      context.commit(MAP_VIEW_ADD, {
        extent: map.getView().calculateExtent(map.getSize()),
        size: map.getSize(),
        zoom: map.getView().getZoom()
      })

      context.commit(MAP_CURRENT_VIEW_INDEX_INCREMENT);
    }
  },
  [MAP_PREVIOUS_VIEW_MOVE](context, map) {
    let currentViewIndex = context.getters.currentViewIndex;

    if (currentViewIndex > 0) {
      context.commit(MAP_VIEW_RESTORING_SET, true);

      let historyItem = context.getters.getViewByIndex(currentViewIndex - 1);

      map.getView().fit(historyItem.extent, historyItem.size);
      map.getView().setZoom(historyItem.zoom);
      setTimeout(function () {
        context.commit(MAP_VIEW_RESTORING_SET, false);
      }, 360);

      context.commit(MAP_CURRENT_VIEW_INDEX_DECREMENT);
    }
  },
  [MAP_NEXT_VIEW_MOVE](context, map) {
    let currentViewIndex = context.getters.currentViewIndex;

    if (currentViewIndex < state.views.length - 1) {
      context.commit(MAP_VIEW_RESTORING_SET, true);

      let historyItem = context.getters.getViewByIndex(currentViewIndex + 1);

      map.getView().fit(historyItem.extent, historyItem.size);
      map.getView().setZoom(historyItem.zoom);

      setTimeout(function () {
        context.commit(MAP_VIEW_RESTORING_SET, false);
      }, 360);

      context.commit(MAP_CURRENT_VIEW_INDEX_INCREMENT);
    }
  },
};

export const mutations = {
    [MAP_CURRENT_VIEW_INDEX_INCREMENT](state) {
        state.currentViewIndex++;
    },
    [MAP_CURRENT_VIEW_INDEX_DECREMENT](state) {
        state.currentViewIndex--;
    },
    [MAP_VIEW_ADD](state, view) {
        state.views.push(view);
    },
    [MAP_LAST_VIEW_REMOVE](state) {
        state.views.pop();
    },
    [MAP_VIEW_RESTORING_SET](state, value) {
        state.isViewRestoring = value;
    },
    [MAP_COORDINATE_SYSTEM_SET](state, coordinateSystem){
        state.coordinateSystem = coordinateSystem;
    },
    [MAP_ZOOM_SET](state, zoom){
        state.zoom = zoom;
    },
    [MAP_RESOLUTION_SET](state, resolution){
      state.resolution = resolution;
    },
    [DATA_FEED_ID_SET](state, id) {
      state.dataFeedId = id;
    },
    [DATA_FEED_TYPE_SET](state, type) {
      state.dataFeedType = type;
    },
    [DATA_FEED_NO_GEOMETRY_LAYER_ID_SET](state, layerId) {
      state.dataFeedNoGeometryLayerId = layerId;
    },
    [MAP_SCALE_SET](state, scale) {
      state.scale = scale;
    },
    [VIEW_CENTER_SET](state, center) {
      state.center = center;
    },
    [MAP_HISTORY_DATA_MODE_SET](state, value){
      state.isHistoryDataMode = value;
    }
};

const getters = {
    currentViewIndex(state) {
        return state.currentViewIndex;
    },
    isViewRestoring(state) {
        return state.isViewRestoring;
    },
    views(state) {
        return state.views;
    },
    getViewByIndex: (state) => (index) => {
        return state.views[index];
    },
    coordinateSystem(state) {
        return state.coordinateSystem;
    },
    zoom(state) {
        return state.zoom;
    },
    resolution(state) {
      return state.resolution;
    },
    editMode(state){
      return state.editMode;
    },
    dataFeedId(state) {
      return state.dataFeedId;
    },
    dataFeedType(state) {
      return state.dataFeedType;
    },
    dataFeedNoGeometryLayerId(state) {
      return state.dataFeedNoGeometryLayerId;
    },
    scale() {
      return state.scale;
    },
    viewCenter(state) {
      return state.center
    },
    isHistoryDataMode(state){
      return state.isHistoryDataMode;
    },
    currentViewExtent(state) {
      if (Array.isArray(state.views) && state.views.length > 0 && state.currentViewIndex >= 0 && state.currentViewIndex < state.views.length) {
        const currentView = state.views[state.currentViewIndex];
        if (currentView) {
          return currentView.extent;
        }
      }
    }
};

export default {
  state,
  actions,
  mutations,
  getters
};
